function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment, useContext, useState, useMemo, useRef, useEffect } from "react";
import ThemeContext from "../ThemeProvider/ThemeContext";
import useStyle, { CONTENT_DURATION } from "./Panel.style";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { renderWithPortal } from "./components/renderWithPortal";
import { BreakpointsContext } from "../Breakpoints/BreakpointsProvider";
import { useScrollLock } from "../../hooks/useScrollLock";
import { isFunction } from "../../utils/is";
import debounce from "lodash/debounce";
import Scrim from "../Scrim/Scrim";
import { Transition } from "../Transition/Transition";
import EventSetter from "../EventSetter";
import { CarinaContext } from "../CarinaProvider";
import { transitionDurationToNum } from "../../utils/styleUtils";
import { Collapse } from "../Collapse";
import { applySpreaderProp } from "../../utils/applySpreaderProp";
import { getScrimZIndex, getZIndex, ZIndexProvider } from "../ZIndexProvider";
export default function Panel(_param) {
    var _animationFunction = _param.animationFunction, animationFunction = _animationFunction === void 0 ? 'productive' : _animationFunction, children = _param.children, collapseProps = _param.collapseProps, _elevated = _param.elevated, elevated = _elevated === void 0 ? false : _elevated, _format = _param.format, format = _format === void 0 ? 'end' : _format, hasScrim = _param.hasScrim, isOpen = _param.isOpen, isRtl = _param.isRtl, _onAnimationOut = _param.onAnimationOut, onAnimationOut = _onAnimationOut === void 0 ? function() {} : _onAnimationOut, onDismiss = _param.onDismiss, onKeyDown = _param.onKeyDown, _portal = _param.portal, portal = _portal === void 0 ? false : _portal, _scrollLock = _param.scrollLock, scrollLock = _scrollLock === void 0 ? true : _scrollLock, testID = _param.testID, transitionProps = _param.transitionProps, zIndexIn = _param.zIndex, restProps = _objectWithoutProperties(_param, [
        "animationFunction",
        "children",
        "collapseProps",
        "elevated",
        "format",
        "hasScrim",
        "isOpen",
        "isRtl",
        "onAnimationOut",
        "onDismiss",
        "onKeyDown",
        "portal",
        "scrollLock",
        "testID",
        "transitionProps",
        "zIndex"
    ]);
    var ref6 = _slicedToArray(useState(false), 2), mountPanel = ref6[0], setMountPanel = ref6[1];
    var outerContainerRef = useRef(null);
    var ref1 = useContext(BreakpointsContext), isL = ref1.isL, isXL = ref1.isXL;
    var isElevated = !isL && !isXL || elevated;
    var correctedHasScrim = hasScrim && isElevated;
    var ref2;
    var ref3 = (ref2 = useContext(CarinaContext)) !== null && ref2 !== void 0 ? ref2 : {
        flags: {
            zIndexUpdates: false
        },
        prefersReducedMotion: false
    }, prefersReducedMotion = ref3.prefersReducedMotion, flags = ref3.flags;
    var zIndexUpdates = flags.zIndexUpdates;
    var zIndex = zIndexUpdates ? getZIndex('panel') : zIndexIn !== null && zIndexIn !== void 0 ? zIndexIn : 3;
    var ref4 = useContext(ThemeContext), duration = ref4.animation.duration;
    var ref5 = useStyle({
        elevated: isElevated,
        format: format,
        isRtl: isRtl,
        zIndex: zIndex
    }), outerContainerStyle = ref5.outerContainerStyle, contentContainerStyle = ref5.contentContainerStyle, collapseCommonStyle = ref5.collapseCommonStyle;
    var fullDuration = useFullDuration({
        animationFunction: animationFunction,
        hasScrim: correctedHasScrim
    });
    var transitions = useTransitions({
        animationFunction: animationFunction,
        format: format,
        hasScrim: correctedHasScrim,
        isRtl: isRtl
    });
    var handleAnimationOut = function(e) {
        setMountPanel(false);
        if (onAnimationOut) {
            onAnimationOut(e);
        }
    };
    var debouncedOnAnimationOut = debounce(function(e) {
        return !isOpen && isFunction(handleAnimationOut) && handleAnimationOut(e);
    }, CONTENT_DURATION);
    useEffect(function() {
        if (isOpen) setMountPanel(true);
    }, [
        isOpen
    ]);
    useScrollLock({
        isOpen: isOpen,
        hasOverlayMounted: mountPanel,
        scrollLock: !!scrollLock && scrollLock
    });
    var calculatedTransitionProps = applySpreaderProp(transitionProps, {
        appear: true,
        duration: fullDuration,
        easing: prefersReducedMotion ? 'linear' : "".concat(animationFunction, ".easeOut"),
        in: isOpen,
        transitions: transitions,
        unmountOnExit: true
    });
    var calculatedCollapseProps = applySpreaderProp(collapseProps, {
        appear: true,
        duration: {
            enter: animationFunction === 'productive' ? transitionDurationToNum(duration[200]) : transitionDurationToNum(duration[400]),
            exit: transitionDurationToNum(duration[200])
        },
        easing: "".concat(animationFunction, ".easeOut"),
        in: isOpen,
        isCollapseDisabled: isElevated || prefersReducedMotion,
        orientation: 'horizontal',
        transitions: {
            common: collapseCommonStyle,
            transitionProperty: ''
        },
        unmountOnExit: isElevated,
        wrapperStyles: {
            height: '100%'
        }
    });
    return renderWithPortal(_jsx(ZIndexProvider, {
        kind: "panel",
        children: _jsx(Transition, _objectSpread({}, calculatedTransitionProps, {
            children: function(param) {
                var _styles = param.styles, scrim = _styles.scrim, panel = _styles.panel, panelContent = _styles.panelContent, ref = param.ref;
                return _jsxs("div", {
                    ref: ref,
                    css: {
                        height: '100%'
                    },
                    children: [
                        correctedHasScrim && _jsx(Scrim, {
                            css: scrim,
                            testID: "".concat(testID, "-scrim"),
                            zIndex: zIndexUpdates && typeof zIndex === 'number' ? getScrimZIndex(zIndex) : zIndex
                        }),
                        _jsx(EventSetter, {
                            containerRef: outerContainerRef,
                            onDismiss: correctedHasScrim ? onDismiss : undefined,
                            children: _jsx(Collapse, _objectSpread({}, calculatedCollapseProps, {
                                children: _jsx("div", _objectSpread({}, injectTestId(testID), restProps, {
                                    css: isElevated ? _objectSpread({}, outerContainerStyle, panel) : outerContainerStyle,
                                    onAnimationEnd: debouncedOnAnimationOut,
                                    onKeyDown: handleKeyDown(onDismiss, onKeyDown),
                                    ref: outerContainerRef,
                                    children: _jsx("div", {
                                        css: _objectSpread({}, contentContainerStyle, panelContent),
                                        children: children
                                    })
                                }))
                            }))
                        })
                    ]
                });
            }
        }))
    }), portal) || _jsx(Fragment, {});
};
var useFullDuration = function(param) {
    var animationFunction = param.animationFunction, hasScrim = param.hasScrim;
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var ref7 = useContext(ThemeContext), duration = ref7.animation.duration;
    if (prefersReducedMotion) {
        return transitionDurationToNum(duration.reducedMotion);
    }
    var longestEnterWithScrim = transitionDurationToNum(duration[200]) + (animationFunction === 'productive' ? transitionDurationToNum(duration[400]) : transitionDurationToNum(duration[800]));
    var longestEnterNoScrim = transitionDurationToNum(duration[200]) + (animationFunction === 'productive' ? transitionDurationToNum(duration[200]) : transitionDurationToNum(duration[400]));
    var longestExitWithScrim = transitionDurationToNum(duration[200]) + transitionDurationToNum(duration[200]);
    var longestExitNoScrim = transitionDurationToNum(duration[200]);
    return {
        enter: hasScrim ? longestEnterWithScrim : longestEnterNoScrim,
        exit: hasScrim ? longestExitWithScrim : longestExitNoScrim
    };
};
var useTransitions = function(param) {
    var animationFunction = param.animationFunction, format = param.format, hasScrim = param.hasScrim, isRtl = param.isRtl;
    var ref;
    var ref8 = (ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false,
        direction: 'ltr'
    }, prefersReducedMotion = ref8.prefersReducedMotion, direction = ref8.direction;
    var ref9 = useContext(ThemeContext), _animation = ref9.animation, duration = _animation.duration, productive = _animation.productive, linear = _animation.linear;
    return useMemo(function() {
        var correctedIsRtl = isRtl !== null && isRtl !== void 0 ? isRtl : direction === 'rtl';
        var directionMultiplier = format === 'end' && !correctedIsRtl || format === 'start' && correctedIsRtl ? 1 : -1;
        var commonDuration = animationFunction === 'productive' ? duration[200] : duration[400];
        var contentDelayWithScrim = animationFunction === 'productive' ? duration[400] : duration[800];
        var scrimIn = {
            opacity: 1,
            transitionDuration: prefersReducedMotion ? duration.reducedMotion : commonDuration,
            transitionProperty: 'opacity'
        };
        var scrimOut = _objectSpread({
            opacity: 0
        }, !prefersReducedMotion && {
            transitionDelay: duration[200]
        }, {
            transitionDuration: prefersReducedMotion ? duration.reducedMotion : duration[200],
            transitionProperty: 'opacity'
        });
        var panelIn = _objectSpread({
            transform: 'translateX(0)'
        }, hasScrim && !prefersReducedMotion && {
            transitionDelay: commonDuration
        }, {
            transitionDuration: prefersReducedMotion ? duration.reducedMotion : commonDuration,
            transitionProperty: prefersReducedMotion ? 'none' : 'transform, box-shadow'
        });
        var panelOut = {
            transform: "translateX(calc(".concat(directionMultiplier, " * 100%))"),
            transitionDuration: prefersReducedMotion ? duration.reducedMotion : duration[200],
            transitionProperty: prefersReducedMotion ? 'none' : 'transform, box-shadow'
        };
        var contentIn = _objectSpread({
            opacity: 1
        }, !prefersReducedMotion && {
            transitionDelay: hasScrim ? contentDelayWithScrim : commonDuration
        }, {
            transitionDuration: prefersReducedMotion ? duration.reducedMotion : duration[200],
            transitionProperty: 'opacity',
            transitionTimingFunction: prefersReducedMotion ? linear.easing : productive.easeIn.easing
        });
        var contentOut = {
            opacity: 0,
            transitionDuration: prefersReducedMotion ? duration.reducedMotion : duration[200],
            transitionProperty: 'opacity',
            transitionTimingFunction: prefersReducedMotion ? linear.easing : productive.easeIn.easing
        };
        return {
            in: {
                scrim: scrimIn,
                panelContent: contentIn
            },
            out: {
                scrim: scrimOut,
                panelContent: contentOut
            },
            enter: {
                panel: panelIn
            },
            entering: {
                panel: panelIn
            },
            exit: {
                panel: panelOut
            },
            exiting: {
                panel: _objectSpread({}, panelOut, {
                    boxShadow: 'none'
                }),
                panelContent: contentIn
            },
            exited: {
                panel: _objectSpread({}, panelOut, {
                    boxShadow: 'none'
                })
            },
            transitionProperty: ''
        };
    }, [
        animationFunction,
        format,
        hasScrim,
        isRtl,
        prefersReducedMotion,
        duration,
        productive,
        linear,
        direction
    ]);
};
function handleKeyDown(onDismiss, onKeyDown) {
    return function(event) {
        if (event.key === 'Escape') {
            if (typeof onDismiss === 'function') {
                onDismiss();
            }
        }
        if (typeof onKeyDown === 'function') {
            onKeyDown(event);
        }
    };
}
